import SessionHelper from "../Helper/SessionHelper";

class CheckOutDetailsRequest{
    CheckOutDetailsURL(){
        return process.env.REACT_APP_BASEURL+"CartTotal/"+SessionHelper.getMobile()+"/"+SessionHelper.getCity()+"/"+SessionHelper.getDeliveryType();
    }
}

export const {CheckOutDetailsURL}=new CheckOutDetailsRequest();